var utils = require('./tripletrax.utils.js');
var views = require('./tripletrax.views.js');

function setControlsDependingOnRights(elementGroup, isOwnFacility, isLocked) {

    let contentData = $('.tt-content').data();
    if (!utils.isUndefined(contentData) && contentData.rights != '') {

        let allRights = contentData.rights;
        utils.updateGlobals('rights', allRights);
		if ('show_patientdata_anonymized' in allRights) {
			utils.updateGlobals('showPatientDataAnonymized', parseInt(allRights['show_patientdata_anonymized'].toString()));
		}
        let existingRoleRights = [
            'read',
            'write',
            'update',
            'delete',
            'export',
            'audittrail',
            'create_query',
            'answer_query',
            'close_query',
            'delete_query'
        ];
        let lockedRoleRights = [
            'read',
            'export',
            'audittrail'
        ];
        $.each($(elementGroup).find('[class^="tt-rightclass-"]'), function(i, rightClassElement) {

            let role = $(rightClassElement).data().role;
            if (role !== '') {
                let isAdmin = /^admin/.test(role);
                let locked = isLocked || (!isOwnFacility && !$(rightClassElement).hasClass('tt-is-in-every-facility'));

                $.each(existingRoleRights, function (rightName) {

                    if ((!locked || (locked && rightName in lockedRoleRights)) && role + '-' + rightName in allRights && allRights[role + '-' + rightName] == 1) {
                        if (!isAdmin) {
                            setButtonsDisabledDependingOnRight(rightClassElement, role, rightName, true);
                        }
                    } else {
                        if (isAdmin) {
                            setElementDisabledDependingOnRight(rightClassElement, rightName, true);
                            setButtonsDisabledDependingOnRight(rightClassElement, role, rightName, false);
                        } else {
                            setButtonsDisabledDependingOnRight(rightClassElement, role, rightName, false);
                        }
                    }
                });
                $(rightClassElement).data('locked', locked);

                if (!isAdmin) {
                    if (!locked && role + '-update' in allRights && allRights[role + '-' + 'update'] == 1 && role + '-write' in allRights && allRights[role + '-' + 'write'] == 1) {
                        setViewButtonsDisabledDependingOnRight(rightClassElement, true);
                    } else {
                        setElementDisabledDependingOnRight(rightClassElement, "write", false);
                        setViewButtonsDisabledDependingOnRight(rightClassElement, false);
                    }

                    if (locked || (!(role + '-update' in allRights) && !(role + '-write' in allRights) && !(role + '-delete' in allRights))) {
                        setUnlockButtonDisabledDependingOnRight(rightClassElement, "write");
                    }
                }
            }
        });

        // Wenn die Daten nur anonymisiert angezeigt werden dürfen, dann müssen alle IDAT-Felder inaktiv sein
        if (showPatientsAnonymized() === 1 && $('#locale').data().pseudonymization !== 'none') {
            $.each($(elementGroup).find('[data-match-field]'), function (i, element) {

                if (!utils.isUndefined(element.dataset) && !utils.isUndefined(element.dataset.matchField) && utils.isIDATField(element.dataset.matchField)) {
                    views.setControlEnabled($(element), false, false, false, true, false);
                    $(element).parents('[class^="tt-rightclass-"]').find('.tt-btn-eraser').addClass('hide');
                    $(element).parents('[class^="tt-rightclass-"]').find('.tt-btn-unlock-for-editing').addClass('hide');
                    $(element).parents('[class^="tt-rightclass-"]').find('.tt-btn-assume-examination-date').addClass('hide');
                }
            });
        }
    }
}

function setButtonsDisabledDependingOnRight(rightClassElement, rightClass, rightName, doEnable) {

    if (doEnable) {
        if (rightName !== 'delete' && rightClass !== 'create_examination') {
            $(rightClassElement).find('.tt-right-button-' + rightName).removeAttr('disabled');
            $(rightClassElement).find('.tt-right-button-' + rightName).removeClass('disabled');
        }
        $(rightClassElement).find('.tt-right-button-' + rightName).removeClass('no-rights');
        $(rightClassElement).find('.tt-right-delete-button-' + rightName).removeClass('hide');
        $(rightClassElement).find('.tt-right-query-button-' + rightName).removeClass('hide');
    } else {
        $(rightClassElement).find('.tt-right-button-' + rightName).prop('disabled', 'disabled');
        $(rightClassElement).find('.tt-right-button-' + rightName).addClass('no-rights');
        $(rightClassElement).find('.tt-right-button-' + rightName).addClass('disabled');
        $(rightClassElement).find('.tt-right-delete-button-' + rightName).addClass('hide');
        $(rightClassElement).find('.tt-right-query-button-' + rightName).addClass('hide');
    }
}

function setViewButtonsDisabledDependingOnRight(rightClassElement, doEnable) {

    if (doEnable) {
        $(rightClassElement).find('.tt-right-button-change').removeAttr('disabled');
        $(rightClassElement).find('.tt-right-button-change').removeClass('no-rights');
        $(rightClassElement).find('.tt-right-button-change').removeClass('disabled');
    } else {
        $(rightClassElement).find('.tt-right-button-change').prop('disabled', 'disabled');
        $(rightClassElement).find('.tt-right-button-change').addClass('no-rights');
        $(rightClassElement).find('.tt-right-button-change').addClass('disabled');
    }
}

function setUnlockButtonDisabledDependingOnRight(rightClassElement, rightName) {

    $(rightClassElement).find('.tt-right-unlock-button-' + rightName).addClass('hide');
}

function setElementDisabledDependingOnRight(rightClassElement, rightName, isAdmin) {

    if (isAdmin) {
        $(rightClassElement).find('.tt-right-label-' + rightName).addClass('state-disabled');

        $(rightClassElement).find('.tt-right-input-' + rightName).prop('disabled', 'disabled');

        $(rightClassElement).find('.tt-right-select-' + rightName).prop('disabled', 'disabled');

        $(rightClassElement).find('.tt-right-checkbox-' + rightName).prop('disabled', 'disabled');

        $(rightClassElement).find('.tt-right-radio-' + rightName).prop('disabled', true);

        $(rightClassElement).find('.tt-right-dd-' + rightName).find('.dd-handle').addClass('dd-nodrag-tripletrax');

        $(rightClassElement).find('.tt-right-note-editable-' + rightName).prop('contentEditable', false);
    } else {
        $.each($(rightClassElement).find('.tt-right-input-' + rightName + ',.tt-right-select-' + rightName + ',.tt-right-checkbox-' + rightName + ',.tt-right-radio-' + rightName), function(i, element) {
            views.setControlEnabled($(element), false, false, false, true, false);
        });
    }
}

function getRight(element, rightName) {

    let lockedRoleRights = [
        'read',
        'export',
        'audittrail'
    ];

    let data = $(element).parents('[class^="tt-rightclass"]').data();
    let role = data.role;
    let locked = data.locked;

    return (!locked || (locked && rightName in lockedRoleRights)) && role + '-' + rightName in utils.GLOBALS.rights && utils.GLOBALS.rights[role + '-' + rightName] == 1;
}

function showPatientsAnonymized() {

    return utils.GLOBALS.showPatientDataAnonymized;
}

module.exports.setControlsDependingOnRights = setControlsDependingOnRights;
module.exports.getRight = getRight;
module.exports.showPatientsAnonymized = showPatientsAnonymized;
